module.exports = "<button mat-icon-button class=\"subtle\" (click)=\"sync()\">\n    <mat-icon>autorenew</mat-icon>\n</button>\n"